import { render, staticRenderFns } from "./UserStatsBar.vue?vue&type=template&id=52fc4a64&scoped=true"
import script from "./UserStatsBar.vue?vue&type=script&lang=js"
export * from "./UserStatsBar.vue?vue&type=script&lang=js"
import style0 from "./UserStatsBar.vue?vue&type=style&index=0&id=52fc4a64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fc4a64",
  null
  
)

export default component.exports